<template>
  <div class="login-warp-box">
    <div class="login-warp login-warp-head clearfix">
      <div class="login-warp-logo">
        <router-link to="/">
          <svg-icon icon-class="logo" class="login-warp-logo-icon"></svg-icon>
        </router-link>
      </div>
      <div class="login-warp-split">|</div>
      <div class="login-warp-title">{{ $t("page.login.title") }}</div>
    </div>
    <div class="login-warp-content">
      <div class="login-warp-content-main">
        <div class="login-wrap-body" v-show="currLoginType === 0">
          <div class="login-wrap-type-btn" @click="changeLoginType(1)"></div>
          <div id="login-box-one">
            <ul class="login-warp-tab-control clearfix">
              <li @click="loginType(0)" :class="{ active: currTab === 0 }">
                {{ $t("page.login.pwLogin") }}
              </li>
              <li @click="loginType(1)" :class="{ active: currTab === 1 }">
                {{ $t("page.login.smsLogin") }}
              </li>
            </ul>
            <div class="login-warp-tab-content">
              <div class="login-warp-tab-item" v-show="currTab === 0">
                <form class="login-form" method="post" id="fm1">
                  <div class="login-form-item">
                    <input
                      class="username"
                      size="25"
                      tabindex="1"
                      maxlength="50"
                      type="text"
                      :placeholder="$t('page.login.pleaseUn')"
                      accesskey="n"
                      autocomplete="off"
                      v-model="form.username"
                      name="username"
                      value=""
                    />
                    <div
                      class="login-form-item-tip"
                      v-if="acApiErrorObj[acApiError]"
                    >
                      <i class="el-icon-warning"></i>
                      {{ acApiErrorObj[acApiError] }}
                    </div>
                  </div>
                  <div class="login-form-item">
                    <input
                      class="password"
                      type="password"
                      v-model="form.password"
                      size="25"
                      maxlength="30"
                      :placeholder="$t('page.login.pleasePw')"
                      tabindex="2"
                      accesskey="p"
                      autocomplete="off"
                      name="password"
                      value=""
                    />
                    <div
                      class="login-form-item-tip"
                      v-if="pwApiErrorObj[pwApiError]"
                    >
                      <i class="el-icon-warning"></i>
                      {{ pwApiErrorObj[pwApiError] }}
                    </div>
                  </div>
                  <div class="login-form-item">
                    <!--密码滑块-->
                    <machineCheck
                      key="password-slider"
                      @ncData="ncData"
                      :validateFiled="form.username"
                      id="password-slider"
                      v-if="passwdShow"
                    ></machineCheck>
                  </div>

                  <div class="login-form-item login-form-submit">
                    <button
                      class="login-form-submit"
                      type="button"
                      :disabled="loginDisabled"
                      accesskey="l"
                      tabindex="6"
                      @click="gologin(11)"
                    >
                      {{ $t("page.login.loginName") }}
                    </button>
                  </div>
                </form>
                <router-link to="/retrievePassword" class="retrievePassword"
                  >忘记用户名、密码？</router-link
                >
              </div>
              <div class="login-warp-tab-item" v-show="currTab === 1">
                <form class="login-form" method="post" id="fm2">
                  <input
                    class="required"
                    id="dataType2"
                    name="dataType"
                    size="10"
                    value="1"
                    type="hidden"
                    autocomplete="off"
                  />
                  <div class="login-form-item">
                    <input
                      size="25"
                      maxlength="11"
                      ref="telNumber"
                      type="text"
                      :placeholder="$t('page.login.telNo')"
                      accesskey="n"
                      v-model="form2.username"
                      @blur="checkTelNumber()"
                      autocomplete="off"
                      name="username"
                      value=""
                    />
                    <div
                      class="login-form-item-tip"
                      v-if="telErrorObj[telError]"
                    >
                      <i class="el-icon-warning"></i>
                      {{ telErrorObj[telError] }}
                    </div>
                  </div>
                  <div class="login-form-item">
                    <!--短信滑块-->
                    <machineCheck
                      key="sms-slider"
                      @ncData="ncData"
                      :validateFiled="form2.username"
                      id="sms-slider"
                      v-if="smsShow"
                    ></machineCheck>
                    <div
                      class="login-form-item-tip"
                      v-if="smsSliderErrorObj[smsSliderError]"
                    >
                      <i class="el-icon-warning"></i>
                      {{ smsSliderErrorObj[smsSliderError] }}
                    </div>
                  </div>
                  <div class="login-form-item">
                    <input
                      id="password2"
                      class="messageVerify"
                      type="text"
                      size="25"
                      maxlength="6"
                      :placeholder="$t('page.login.smsVerCode')"
                      tabindex="2"
                      accesskey="p"
                      autocomplete="off"
                      v-model="form2.password"
                      name="password"
                      value=""
                    /><button
                      type="button"
                      class="login-form-item-Vcode"
                      id="btnVcode"
                      @click="sendemail()"
                    >
                      <template v-if="!smsSuccess">
                        <!--发送验证码-->
                        {{ $t("page.login.sendVerCode") }}
                      </template>
                      <template v-else>
                        {{ $t("page.login.sended") }}{{ countdown }}s
                      </template>
                    </button>

                    <div
                      class="login-form-item-tip login-form-item-error-tip"
                      v-if="smsErrorObj[smsError]"
                    >
                      <i class="el-icon-warning"></i>
                      {{ smsErrorObj[smsError] }}
                    </div>
                    <div
                      class="login-form-item-success-tip"
                      v-if="smsSuccess && !smsErrorObj[smsError]"
                    >
                      <div style="color: #999">
                        {{ $t("page.login.smsSendSuccessTip1")
                        }}<span style="color: #FF142F">{{
                          form2.username
                        }}</span
                        >，{{ $t("page.login.smsSendSuccessTip2") }}
                      </div>
                    </div>
                  </div>
                  <div class="login-form-item login-form-submit">
                    <button
                      class="login-form-submit"
                      type="button"
                      :disabled="loginDisabled"
                      accesskey="l"
                      tabindex="6"
                      @click="gologin(12)"
                    >
                      {{ $t("page.login.loginName") }}
                    </button>
                  </div>
                </form>
              </div>
              <div class="login-warp-tab-item" style="display: none"></div>
            </div>
          </div>
          <div id="login-box-two" style="display: none"></div>
          <div id="login-box-three" style="display: none"></div>
        </div>

        <div class="login-wrap-body" v-show="currLoginType === 1">
          <div class="login-wrap-type-btn2" @click="changeLoginType(0)"></div>
          <div>
            <ul class="login-warp-tab-control clearfix">
              <li @click="loginEqType(0)" :class="{ active: currEqTab === 0 }">
                {{ $t("page.login.jjt") }}
              </li>
              <li @click="loginEqType(1)" :class="{ active: currEqTab === 1 }">
                {{ $t("page.login.wx") }}
              </li>
            </ul>
            <div class="login-warp-tab-content">
              <div class="login-warp-tab-item" v-show="currEqTab === 0">
                <div id="qr" class="login-warp-qr"></div>
              </div>
              <div class="login-warp-tab-item" v-show="currEqTab === 1">
                <div id="wxqr" class="login-warp-qr-wx"></div>
              </div>
              <div class="login-warp-tab-item" style="display: none"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="login-warp-footer">
      <span>{{ $t("page.login.Copyright") }}</span>
      <span style="padding: 0 16px;">|</span>
      <span>{{ $t("page.login.statement") }}</span>
    </div>
  </div>
</template>

<script>
import util from "@/basa/utils/util.js";
import WwLogin from "WwLogin";
import WxLogin from "WxLogin";
import machineCheck from "../components/no-captcha";
import { createLoginKey, loginSup, mobile } from "../api/login";
export default {
  name: "login",
  data() {
    return {
      laoshuo: "",
      form: {
        username: "",
        password: "",
        passwdSession: ""
      },
      form2: {
        username: "",
        password: "",
        smsSession: ""
      },
      currLoginType: 0,
      currEqTab: 0,
      currTab: 0,
      loginDisabled: true,
      nc_DataArr: {},
      passwdShow: true, //人机校验显示隐藏
      smsShow: false, //人机校验显示隐藏
      acApiErrorObj: {
        default: null,
        error1: window.$t("page.login.acApiErrorObj.error1"),
        error2: window.$t("page.login.acApiErrorObj.error2"),
        error3: window.$t("page.login.acApiErrorObj.error3"),
        error4: window.$t("page.login.acApiErrorObj.error4")
      },
      acApiError: "default",
      pwApiErrorObj: {
        default: null,
        error1: window.$t("page.login.pwApiErrorObj.error1"),
        error2: window.$t("page.login.pwApiErrorObj.error2")
      },
      pwApiError: "default",
      telErrorObj: {
        default: null,
        error1: window.$t("page.login.telErrorObj.error1"),
        error2: window.$t("page.login.telErrorObj.error2"),
        error3: window.$t("page.login.telErrorObj.error3"),
        error4: window.$t("page.login.telErrorObj.error4")
      },
      telError: "default",
      smsSliderErrorObj: {
        default: null,
        error1: window.$t("page.login.smsSliderErrorObj.error1")
      },
      smsSliderError: "default",
      smsErrorObj: {
        default: null,
        error1: window.$t("page.login.smsErrorObj.error1"),
        error2: window.$t("page.login.smsErrorObj.error2")
      },
      smsError: "default",
      smsSuccess: false,
      currTimer: null,
      countdown: 60
    };
  },
  components: {
    machineCheck
  },
  mounted() {
    this.getLaoshuo();
    this.check();
    this._0x16ede3();
    this._0x3b6e7e();
  },
  methods: {
    loginType(currTab) {
      this.currTab = currTab;
      this.passwdShow = currTab === 0 ? true : false;
      this.smsShow = currTab === 1 ? true : false;
      this.telError = "default";
      this.smsSliderError = "default";
      this.smsError = "default";
      this.pwApiError = "default";
      this.form = {
        username: "",
        password: "",
        passwdSession: ""
      };
      this.form2 = {
        username: "",
        password: "",
        smsSession: ""
      };
    },
    changeLoginType(currLoginType) {
      this.currLoginType = currLoginType;
    },
    loginEqType(currEqTab) {
      this.currEqTab = currEqTab;
    },
    checkTelNumber(fn) {
      if (!this.isPhoneNo(this.form2.username)) {
        this.telError = "error1";
        this.$refs.telNumber.focus();
      } else {
        this.telError = "default";
        fn && fn();
      }
    },
    isPhoneNo(_0x35c582) {
      let _0x2fd900 = /^1\d{10}$/;
      return _0x2fd900["test"](_0x35c582);
    },
    gologin(type) {
      let param;
      if (type === 11) {
        param = {
          username: this.form.username,
          password: util.Encrypt(this.form.password, this.laoshuo),
          encryptKey: util.Encrypt(this.laoshuo, "iccecltdiccecltd"),
          type: type,
          sessionId: this.form.passwdSession,
          callBackUrl: "/"
        };
      }
      if (type === 12) {
        param = {
          username: this.form2.username,
          smsCode: this.form2.password,
          type: type,
          sessionId: this.form2.smsSession,
          callBackUrl: "/"
        };
      }
      loginSup(param)
        .then(res => {
          /*密码登录码值
           * 606 登录账号与登录密码不匹配，请重新输入
           * 607 该登录账号因无效登录超过6次已被锁定30分钟。
           * 310 未实名
           * 608 登录账号已被冻结
           * 999 系统服务暂不可用，请稍后重试
           * 手机登录码值
           * 601 手机号与短信密码不匹配，请重新输入。
           * 602 手机号短信验证码无效登录6次，将锁定手机号30分钟
           * 605 请输入正确手机号码
           * 999 系统服务暂不可用,请稍后重试
           * 短信验证码码值
           * 0 短信验证码已发送至XXXXXX,请查收
           * 999 系统服务暂不可用,请稍后重试
           * 603 短信验证码已发送至XXXXXX,请查收
           * 604 发送验证码失败,请稍后再试
           * 605 请输入正确手机号码
           * */
          if (res.data.code === "0") {
            this.pwApiError = "default";
            this.acApiError = "default";
            this.telError = "default";
            this.smsError = "default";
            window.location.href = "/";
            console.log(res.data);
          }
        })
        .catch(e => {
          console.log(e);
          switch (e.data.code) {
            case "606":
              this.pwApiError = "error1";
              //  登录账号与登录密码不匹配，请重新输入
              break;
            case "607":
              this.acApiError = "error1";
              break;
            case "310":
              this.acApiError = "error2";
              break;
            case "608":
              this.acApiError = "error3";
              break;
            case "601": // 手机号与短信密码不匹配，请重新输入。
              this.telError = "error2";
              break;
            case "602": // 手机号短信验证码无效登录6次，将锁定手机号30分钟
              this.telError = "error3";
              break;
            case "605": // 请输入正确手机号码
              this.telError = "error1";
              break;
            case "604":
              this.smsError = "error2";
              break;
            case "205":
              this.smsSliderError = "error1";
              this.pwApiError = "error2";
              break;
            default:
              // "999" 服务不可用
              this.acApiError = "error4";
              this.telError = "error4";
              break;
          }
        });
    },
    ncData(ncData) {
      this.nc_DataArr = ncData;
      this.loginDisabled = false;
      if (ncData.id === "sms-slider") {
        this.form2.smsSession = ncData.sessionId;
        this.smsSliderError = "default";
      }
      if (ncData.id === "password-slider") {
        this.form.passwdSession = ncData.sessionId;
      }
    },
    check() {},
    sendemail() {
      if (!this.form2.smsSession) {
        this.smsSliderError = "error1";
        return false;
      }
      this.checkTelNumber(() => {
        this.sendCode();
      });
    },
    sendCode() {
      if (this.currTimer) {
        this.smsError = "error1";
        return;
      }
      mobile({
        phoneNumbers: this.form2.username
      }).then(res => {
        if (res) {
          if (res.data.code === "0") {
            switch (res.data.data.loginCode) {
              case "605":
                this.telError = "error1";
                break;
              case "604":
                this.smsError = "error2";
                break;
              case "999":
                this.telError = "error4";
                break;
              default:
                // 发送完后
                if (!this.currTimer) {
                  this.settingTimes();
                }
                break;
            }
          }
        }
      });
    },
    settingTimes() {
      if (this.countdown === 0) {
        this.countdown = 60;
        this.smsSuccess = false;
        this.currTimer = null;
      } else {
        this.smsError = "default";
        this.smsSuccess = true;
        this.currTimer = setTimeout(() => {
          this.countdown--;
          this.settingTimes();
        }, 1000);
      }
    },
    _0x16ede3() {
      let hostname = window.location.hostname;
      let env =
        hostname.indexOf("-") !== -1 ? hostname.split("-")[0] + "-" : "";
      let agentid = "1001274";
      let redirect_uri;
      if (env === "") {
        redirect_uri = `http://dev01-mla.iccec.cn/apis/mla/users/signup/JJTWeChatLogin?loginUrl=/`;
      } else {
        redirect_uri = `${location.protocol}//${env}mla.iccec.cn/apis/mla/users/signup/JJTWeChatLogin?loginUrl=/`;
      }
      new WwLogin({
        id: "qr",
        appid: "wl2c5e89d5c4",
        agentid: agentid,
        redirect_uri: redirect_uri,
        state: new Date().getTime(),
        href:
          "data:text/css;base64,LndycF9jb2Rle21hcmdpbi10b3A6IDAgIWltcG9ydGFudDt9DQoubG9naW5QYW5lbHt3aWR0aDogMTg1cHggIWltcG9ydGFudDtwYWRkaW5nOiAwICFpbXBvcnRhbnQ7fQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE4NXB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZSAhaW1wb3J0YW50O30NCi5pbXBvd2VyQm94IC5pbmZvIHt3aWR0aDogMTg1cHg7fQ0KLnN0YXR1c19pY29uIHtkaXNwbGF5Om5vbmUgIWltcG9ydGFudH0NCi5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9DQouaW1wb3dlckJveCAuc3RhdHVze21hcmdpbi10b3A6IDAgIWltcG9ydGFudDt9DQouaW1wb3dlckJveCAuc3RhdHVzX3N1Y2MsIC5pbXBvd2VyQm94IC5zdGF0dXNfZmFpbHttYXJnaW4tbGVmdDogMCAhaW1wb3J0YW50O30="
      });
    },
    _0x3b6e7e() {
      let hostname = window.location.hostname;
      let env =
        hostname.indexOf("-") !== -1 ? hostname.split("-")[0] + "-" : "";
      let appid = "wx97d03c77b7e13db1";
      let redirect_uri = "";
      if (env === "") {
        redirect_uri = `http://dev01-mla.iccec.cn/apis/mla/users/signup/JJTWeChatLogin?loginUrl=/`;
      } else {
        redirect_uri = `${location.protocol}//${env}mla.iccec.cn/apis/mla/users/signup/AppWeChatLogin?loginUrl=/`;
      }
      new WxLogin({
        self_redirect: false,
        id: "wxqr",
        appid: appid,
        scope: "snsapi_login",
        redirect_uri: redirect_uri,
        state: new Date().getTime(),
        style: "",
        href:
          "data:text/css;base64,LndycF9jb2Rle21hcmdpbi10b3A6IDAgIWltcG9ydGFudDt9DQoubG9naW5QYW5lbHt3aWR0aDogMTg1cHggIWltcG9ydGFudDtwYWRkaW5nOiAwICFpbXBvcnRhbnQ7fQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE3NXB4O21hcmdpbi10b3A6IDVweDtib3JkZXI6MDt9DQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmUgIWltcG9ydGFudDt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDE4NXB4O30NCi5zdGF0dXNfaWNvbiB7ZGlzcGxheTpub25lICFpbXBvcnRhbnR9DQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7bWFyZ2luLXRvcDogLThweCAhaW1wb3J0YW50O2NvbG9yOiAjNzM3Qzg0O30NCi5pbXBvd2VyQm94IC5zdGF0dXNfc3VjYywgLmltcG93ZXJCb3ggLnN0YXR1c19mYWlse21hcmdpbi1sZWZ0OiAwICFpbXBvcnRhbnQ7fQ=="
      });
    },
    getLaoshuo() {
      createLoginKey({}).then(res => {
        this.laoshuo = res.data.data;
      });
    }
  },
  beforeCreate() {
    document.body.className = "loginWrap";
    //document.getElementsByClassName("ccui-top-bar-wrapper")[0].remove();
  },
  beforeDestroy() {
    document.body.className = "";
  }
};
</script>
<style lang="scss">
.loginWrap {
  .ccui-top-bar-wrapper {
    display: none;
  }
}
</style>
<style scoped lang="scss">
.login-warp-box {
  width: 100%;
  min-width: 1180px;
  background: #ffffff;
  height: 100vh;
}
.login-warp {
  width: 1180px;
  position: relative;
  margin: 0 auto;
}
.login-warp-head {
  padding-top: 26px;
  padding-bottom: 25px;
  .login-warp-logo {
    float: left;
    width: 256px;
    /deep/ .svg-icon {
      width: 256px;
      height: 68px;
    }
  }
  .login-warp-split {
    float: left;
    font-size: 26px;
    line-height: 68px;
    font-weight: 800;
    color: #4a4a4a;
    padding: 0 20px;
  }
  .login-warp-title {
    float: left;
    font-size: 26px;
    line-height: 68px;
    font-weight: 800;
    color: #4a4a4a;
  }
}
.login-warp-content {
  width: 100%;
  min-width: 1180px;
  height: 530px;
  background: url("../../../basa/assets/images/bannerBg.png") repeat-x;
  .login-warp-content-main {
    position: relative;
    width: 1280px;
    margin: 0 auto;
    height: 530px;
    background: url("../../../basa/assets/images/banner.png") no-repeat;
    .login-wrap-body {
      position: absolute;
      top: 71px;
      right: 87px;
      width: 400px;
      height: 412px;
      background: #ffffff;
      box-shadow: 0px 5px 21px 0px rgba(14, 42, 79, 0.23);
      border-radius: 2px;
      .login-wrap-type-btn {
        position: absolute;
        top: -5px;
        right: -5px;
        width: 86px;
        height: 86px;
        cursor: pointer;
        z-index: 10000;
        background: url("../../../basa/assets/images/login2-btn.png") no-repeat
          50% 50%;
      }
      .login-wrap-type-btn2 {
        position: absolute;
        top: -5px;
        right: -5px;
        width: 86px;
        height: 86px;
        cursor: pointer;
        z-index: 10000;
        background: url("../../../basa/assets/images/login1-btn.png") no-repeat
          50% 50%;
      }
      .login-warp-tab-control {
        width: 344px;
        margin: 0 auto;
        padding-top: 47px;
        li {
          float: left;
          padding: 0 10px;
          display: inline-block;
          height: 34px;
          line-height: 28px;
          color: #9b9b9b;
          cursor: pointer;
          font-size: 20px;
          font-weight: 600;
          border-bottom: 2px solid #ffffff;
          &.active {
            border-bottom: 2px solid #0089ef;
            color: #0089ef;
          }
          & + li {
            margin-left: 22px;
          }
        }
      }
    }
  }
}
.login-warp-qr {
  margin: 36px auto 0;
  height: 290px;
  width: 300px;
}
.login-warp-qr-wx {
  margin: 36px auto 0;
  height: 290px;
  width: 300px;
}
.retrievePassword {
  font-size: 13px;
  font-weight: 500;
  color: #666666;
  line-height: 18px;
  text-align: center;
  width: 100%;
  display: inline-block;
  margin-top: 10px;
}
.login-form {
  padding-top: 10px;
  .login-form-item {
    margin-top: 25px;
    padding-left: 39px;
    position: relative;
    &.login-form-submit {
      margin-top: 35px;
    }
    .login-form-item-tip {
      font-size: 12px;
      color: #d50a0c;
      line-height: 16px;
      position: absolute;
      bottom: -20px;
      padding-left: 20px;
      .el-icon-warning {
        font-size: 16px;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    .login-form-item-error-tip {
      line-height: 36px;
      bottom: -36px;
      font-size: 12px;
      color: #d50a0c;
      position: absolute;
      padding-left: 20px;
      .el-icon-warning {
        font-size: 16px;
        position: absolute;
        left: 0;
        top: 10px;
      }
    }
    .login-form-item-success-tip {
      font-size: 12px;
      color: #d50a0c;
      line-height: 36px;
      position: absolute;
      bottom: -36px;
    }
    input {
      width: 322px;
      height: 42px;
      box-sizing: border-box;
      line-height: 42px;
      font-size: 14px;
      padding-left: 10px;
      border: 1px solid #cccccc;
      vertical-align: middle;
      &:focus {
        outline: -webkit-focus-ring-color auto 0px;
      }
      &.error {
        background: rgba(255, 248, 248, 1);
        border: 1px solid rgba(255, 162, 162, 1);
        box-shadow: 0 0 0 0 rgba(85, 118, 207, 0);
      }
    }
    .login-form-submit {
      cursor: pointer;
      width: 322px;
      border: 0;
      height: 35px;
      line-height: 35px;
      background: rgba(56, 136, 255, 1);
      color: #ffffff;
      border-radius: 2px;
      box-sizing: border-box;
      font-size: 13px;
      &:disabled {
        background: rgba(56, 136, 255, 0.6);
      }
      &:focus {
        outline: -webkit-focus-ring-color auto 0px;
      }
    }
    .login-form-item-Vcode {
      position: absolute;
      top: 1px;
      text-indent: 10px;
      width: 90px;
      height: 40px;
      right: 40px;
      bottom: 36px;
      border: none;
      font-size: 14px;
      padding: 0;
      text-align: left;
      color: #0089ef;
      outline: none;
      background: none;
      border-left: 1px solid #d8d8d8;
      cursor: pointer;
    }
  }
}

.login-warp-footer {
  padding: 48px 0 54px;
  font-size: 13px;
  color: #4a4a4a;
  line-height: 18px;
  text-align: center;
}
</style>
